import { connect, useDispatch } from 'react-redux';
import React, { ReactElement, Suspense, useEffect, useState } from 'react';
import { IntStore } from '../../schemas/store.interface';
import { useHistory } from 'react-router';
import { getStoreList , getStoreInformation ,getDpr,getCountry , postStores }from './choose-store.service';
import { InitChooseStore }from '../../schemas/choose-store.interface';
import {showLoading} from '../../components/ui/loading/loading.reducer';
import { formatDate, getCodeCompany } from '../user/user.service';
import { getCompany } from '../../core/session-storage/session-storage.service';
import { useTranslation } from 'react-i18next';
import { setIsSotoreSelected } from '../baggage/baggabe.reducer';
import { environment } from '../../environments/environment';
import { formatDateByLanguage } from '../baggage/confirm-baggage/confirm-baggage.service';

const ChooseStore = (props: InitChooseStore): ReactElement => {

  const { t } = useTranslation();
  const companyStorage = getCompany();
  const history = useHistory();
  const dispatch = useDispatch();
  const [storeList, setstoreList] = useState([])
  const [isStoreSelect, setisStoreSelect] = useState(false);
  const [isStoreSelectProc, setisStoreSelectProc] = useState(false);
  const [dataStore, setdataStore]:any = useState({});
  const [country, setCountry] = useState('')

  useEffect(() => {
    let isMounted = true;

    async function load() {
      props.showLoading();
      const storelistResponse = await props.getStoreList(props.user.lossAgentParentId, history);
      const payloadGetCountry = {
        lossAgentParentId:props.user.lossAgentParentId,
        language:props.user.language.slice(3, 5),
      }
      const responseCountry = await props.getCountry(payloadGetCountry, history);
      
      if (isMounted) {
        setCountry(responseCountry.data.name);

        const payloadDprs = {
          Pir: props.user.userForm.pir,
          PirDate:formatDate(props.user.userForm.fechaIncidencia),
          Firm:getCodeCompany(companyStorage),
          User:props.user.userForm.apellido,
        }
        const responseDpr = await props.getDpr(payloadDprs, history);

        if(responseDpr && responseDpr.data && responseDpr.data.hasOwnProperty('homeAddress')){
          setisStoreSelect(true);
        }
        setstoreList(storelistResponse);
      }
    }
    if(!props.baggage.isStoreSelected){
      load();
    }else{
      setdataStore(props.baggage.pir_redirect);
      setisStoreSelect(true);
    }
    
    return () => {
      isMounted = false;
    };
  }, []);


  const storeSelected = async (e,item) => {
    e.preventDefault();
    if (isStoreSelectProc==false)
    {
      setisStoreSelectProc(true);
      try {
        const storeResponse = await props.getStoreInformation(props.user.lossAgentParentId , item.borrowerAssistanceId , history );
        const payload = {
          lossAgentParentId: props.user.lossAgentParentId,
          pir: props.user.userForm.pir,
          data: {
            ...storeResponse
          }
        }

        const postStoresResponse = await props.postStores(payload , history );
        setdataStore(postStoresResponse);
        setisStoreSelect(true);
        dispatch(setIsSotoreSelected(true));
      } catch (error) {
        console.error('Error selecting store:', error);
        setisStoreSelectProc(false);
      }
    }
  }

  const closeStore = () => {
    history.push('/' + companyStorage + '/pir');
  }

  const vlg_rlink = t(`${companyStorage}.choose_store.refund_link_url`);
  const def_rlink = `${environment.static.pdfs}/${companyStorage}/${props.user.language}/reembolso_${getCodeCompany(companyStorage)}.pdf`;

  const ibe_contact_rlink = t(`iberia.choose_store.refund_link_contacto_url`);
  const ibe_claims_rlink = t(`iberia.choose_store.refund_link_reclamaciones_url`);

  const isIberia = getCodeCompany(companyStorage) === 'IBE';

  return (
    <Suspense fallback="">
      {!isStoreSelect &&(
        <div className="card choose-store">
          {storeList && storeList.length > 0 ? (
            <>
              {t(`${companyStorage}.choose_store.title_first`)} <b> {country} </b>
              {t(`${companyStorage}.choose_store.title_second`)}
              <ul className="store-list">
              {storeList.map((item:any, index)=>(
                  <li className="store-item" key={item.borrowerAssistanceId + '_' + index }>
                    {/* WCAG 2.1.1 / 4.1.2: la tienda se selecciona con un boton nativo. */}
                    <button type="button" className="store-button" onClick={(e)=>storeSelected(e,item)}>
                      <p className="store-address">{item.address}</p>
                      <p className="commercialName">{item.commercialName}</p>
                      <p className="homeAddress">{item.homeAddress} - {item.town}</p>
                      <p className="phone">{item.phone}</p>
                    </button>
                  </li>
              ))}
              </ul>
            </>
          ) : (
            <>
              <p>{t(`${companyStorage}.choose_store.no_stores_title`)}</p>
              <p>{t(`${companyStorage}.choose_store.no_stores_subtitle`)}</p>
            </>
          )}
          <div className="refund-section">
            {storeList && storeList.length > 0 && (
              <p>{t(`${companyStorage}.choose_store.refund`)}</p>
            )}
            {isIberia ? (
              <div style={{ display: 'block', marginBottom: '6px' }}>
                <a href={ibe_contact_rlink} target="_blank" rel="noopener noreferrer" style={{ display: 'block', marginBottom: '4px' }}>
                  {t(`iberia.choose_store.refund_link_contacto_lbl`)}<span className="sr-only"> {t('A11Y_NUEVA_VENTANA')}</span>
                </a>
                <a href={ibe_claims_rlink} target="_blank" rel="noopener noreferrer" style={{ display: 'block' }}>
                  {t(`iberia.choose_store.refund_link_reclamaciones_lbl`)}<span className="sr-only"> {t('A11Y_NUEVA_VENTANA')}</span>
                </a>
              </div>
            ) : (
              <a href={{ 'vueling': vlg_rlink }[companyStorage] || def_rlink} target="_blank" rel="noopener noreferrer">
                {t(`${companyStorage}.choose_store.refund_link`)}<span className="sr-only"> {t('A11Y_NUEVA_VENTANA')}</span>
              </a>
            )}
          </div>
         <div className="btn-wrapper">
              <button data-qa="submit-pir" className="btn btn--primary" id="btn-user-continue" onClick={()=>closeStore()}>{t(`${companyStorage}.choose_store.cancel`)}</button>
          </div>
      </div>
      )}





      {isStoreSelect && (
        <div className="card choose-store" data-testid="chooseStoreSucess">
          <h2>{t(`${companyStorage}.choose_store.success_title`)}</h2>
          <p>{t(`${companyStorage}.choose_store.success_message`, { 
            date: formatDateByLanguage(props.user.userForm.fechaIncidencia?.toISOString(), props.user.language.split('-')[0].toUpperCase()), 
            reference: dataStore.wo 
          })}.</p>
          <br />
          <p style={{ marginBottom: '10px' }}>{t(`${companyStorage}.choose_store.provider_section_title`)}</p>
          <div style={{ marginBottom: '0px' }}>
            <strong>{t(`${companyStorage}.choose_store.provider_label`)}:</strong> {dataStore.supplier}
          </div>
          <div style={{ marginBottom: '0px' }}>
            <strong>{t(`${companyStorage}.choose_store.address_label`)}:</strong> {dataStore.homeAddress}
          </div>
          <div style={{ marginBottom: '0px' }}>
            <strong>{t(`${companyStorage}.choose_store.locality_label`)}:</strong> {dataStore.city}
          </div>
          <div style={{ marginBottom: '0px' }}>
            <strong>{t(`${companyStorage}.choose_store.phone_label`)}:</strong> {dataStore.phone}
          </div>
          <br />
          <h3>{t(`${companyStorage}.choose_store.documentation_title`)}</h3>
          <p>{t(`${companyStorage}.choose_store.documentation_title_2`)}</p>
          <ul style={{ marginLeft: '40px', listStyle: 'unset !important' }}>
            <li style={{ marginBottom: '0px' }}><span>{t(`${companyStorage}.choose_store.reference_number`)}: <strong>{dataStore.wo}</strong></span></li>
            <li style={{ marginBottom: '0px' }}><span>{t(`${companyStorage}.choose_store.pir`)}</span></li>
            <li style={{ marginBottom: '0px' }}><span>{t(`${companyStorage}.choose_store.original_tags`)}</span></li>
            <li style={{ marginBottom: '0px' }}><span>{t(`${companyStorage}.choose_store.original_boarding_pass`)}</span></li>
            <li style={{ marginBottom: '0px' }}><span>{t(`${companyStorage}.choose_store.dni`)}</span></li>
            <li style={{ marginBottom: '0px' }}><span>{t(`${companyStorage}.choose_store.baggage`)}</span></li>
          </ul>
          <br />
          <h3>{t(`${companyStorage}.choose_store.thank_you`)}</h3>

          <div className="btn-wrapper">
            <button data-qa="submit-pir" className="btn btn--primary" id="btn-user-continue" onClick={closeStore}>{t(`${companyStorage}.choose_store.btn_back`)}</button>
          </div>
        </div>
      )}

    </Suspense>
  );
};

const mapStateToProps = (state: IntStore) => {
  return {
    user:state.user,
    baggage:state.baggage
  };
};

const mapDispatchToProps = {
  getStoreList,
  showLoading,
  getStoreInformation,
  getDpr,
  getCountry,
  postStores
};

export default connect(mapStateToProps, mapDispatchToProps)(ChooseStore);
